var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { display: "flex", "flex-direction": "column", gap: "12px" },
    },
    [
      _vm.isMechanismHypothesisLoading
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center gap-2 my-2",
              staticStyle: { color: "#555" },
            },
            [
              _c("b-spinner", { attrs: { small: "" } }),
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("LLM: Generating mechanistic hypotheses"),
              ]),
              _vm.revealHypothesisStep
                ? _c("span", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(
                        _vm.helpers.formatTime(_vm.revealHypothesisStep.time) ||
                          _vm.helpers.currStepTime(_vm.revealHypothesisStep)
                      )
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.isMechanismHypothesisLoading && _vm.errorMechanisms
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-danger d-flex align-items-center justify-content-between mt-2",
              attrs: { role: "alert" },
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.errorMsgMechanisms))]),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("retry-hypotheses")
                    },
                  },
                },
                [_vm._v("Retry")]
              ),
            ]
          )
        : _vm._e(),
      !_vm.isMechanismHypothesisLoading && _vm.showMechanismResultsPanel
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center mb-2",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "font-weight-bold",
                    staticStyle: { color: "#FF6600" },
                  },
                  [
                    _vm.mechanisms && _vm.mechanisms.length
                      ? [
                          _vm._v(
                            "Generated " +
                              _vm._s(_vm.mechanisms.length) +
                              " mechanistic hypotheses."
                          ),
                        ]
                      : [_vm._v("Mechanistic hypotheses")],
                  ],
                  2
                ),
                _vm.canDownloadMechanismReport
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary btn-sm",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("download-report")
                          },
                        },
                      },
                      [_vm._v(" Download report ")]
                    )
                  : _vm._e(),
              ]
            ),
            _vm.mechanismDiagnosticAssessment &&
            _vm.mechanismDiagnosticAssessment.warning_flag
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-warning mb-3",
                    attrs: { role: "status" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "font-weight-bold text-dark mb-1" },
                      [_vm._v("Diagnostic warning")]
                    ),
                    _c("div", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(_vm.mechanismDiagnosticAssessment.warning_flag)
                      ),
                    ]),
                    _vm.mechanismDiagnosticAssessment.suggested_optimized_query
                      ? _c(
                          "div",
                          {
                            staticClass: "mt-2 pt-2 border-top",
                            staticStyle: {
                              "border-color": "rgba(0,0,0,0.08) !important",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "font-weight-bold mb-1" },
                              [_vm._v("Suggested optimized query")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "text-dark mb-2",
                                staticStyle: { "white-space": "pre-wrap" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.mechanismDiagnosticAssessment
                                      .suggested_optimized_query
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-cfde btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit(
                                      "apply-suggested-query",
                                      _vm.mechanismDiagnosticAssessment
                                        .suggested_optimized_query
                                    )
                                  },
                                },
                              },
                              [_vm._v(" Use this query and run Reveal ")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.mechanismDiagnosticAssessment &&
            _vm.mechanismDiagnosticAssessment.can_generate_hypothesis === false
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-secondary border mb-3",
                    attrs: { role: "status" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "font-weight-bold text-dark mb-1" },
                      [
                        _vm._v(
                          "No hypothesis generated (diagnostic assessment)"
                        ),
                      ]
                    ),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm.mechanismDiagnosticAssessment.rejection_reason ||
                            (_vm.isGeneSetEntryMode
                              ? "The model declined to invent connections not supported by the factorization feed."
                              : "The model declined to invent connections not supported by the retrieved graph.")
                        )
                      ),
                    ]),
                    _vm.hypothesisGenerationMode === "strict"
                      ? _c(
                          "div",
                          {
                            staticClass: "mt-2 pt-2 border-top",
                            staticStyle: {
                              "border-color": "rgba(0,0,0,0.08) !important",
                            },
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "mb-2" },
                              [
                                _vm.isGeneSetEntryMode
                                  ? [
                                      _vm._v(
                                        " Strict factorization rules blocked a mechanism. You can run again in "
                                      ),
                                      _c("strong", [_vm._v("Relaxed")]),
                                      _vm._v(
                                        " mode to ask the model for a best-effort, explicitly warned hypothesis (still grounded in the slim gene-set feed). "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        " Retrieval and strict graph rules blocked a mechanism. You can run again in "
                                      ),
                                      _c("strong", [_vm._v("Relaxed")]),
                                      _vm._v(
                                        " mode to ask the model for a best-effort, explicitly warned hypothesis (still grounded in the retrieved CSV). "
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-cfde btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("retry-hypotheses-relaxed")
                                  },
                                },
                              },
                              [_vm._v(" Try in relaxed (exploratory) mode ")]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.mechanismDiagnosticAssessment.suggested_optimized_query
                      ? _c("div", { staticClass: "mt-2 pt-2 border-top" }, [
                          _c("div", { staticClass: "font-weight-bold mb-1" }, [
                            _vm._v("Suggested optimized query"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "text-dark mb-2",
                              staticStyle: { "white-space": "pre-wrap" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.mechanismDiagnosticAssessment
                                    .suggested_optimized_query
                                )
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-cfde btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit(
                                    "apply-suggested-query",
                                    _vm.mechanismDiagnosticAssessment
                                      .suggested_optimized_query
                                  )
                                },
                              },
                            },
                            [_vm._v(" Use this query and run Reveal ")]
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.mechanismResultsDetailVisible
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "section-header d-flex justify-content-between align-items-start mb-2",
                      on: {
                        click: function ($event) {
                          _vm.displayMechanisms = !_vm.displayMechanisms
                        },
                      },
                    },
                    [
                      _vm.researchContext
                        ? _c("div", { staticClass: "text-muted" }, [
                            _vm._v("In the context of "),
                            _c("strong", [_vm._v(_vm._s(_vm.researchContext))]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "criteria-detail",
                      class: { collapsed: !_vm.displayMechanisms },
                    },
                    [
                      _vm.reportSessionSummary !== "—"
                        ? _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "strong",
                              {
                                staticClass:
                                  "d-block mb-2 mechanism-card-title",
                              },
                              [_vm._v("Summary")]
                            ),
                            _c("div", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(_vm.reportSessionSummary)),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column gap-4",
                          staticStyle: { gap: "40px" },
                        },
                        [
                          _vm._l(_vm.mechanisms, function (mechanism, idx) {
                            return _c(
                              "div",
                              {
                                key: idx,
                                staticClass:
                                  "mechanism-card rounded border shadow-sm bg-light overflow-hidden",
                              },
                              [
                                _vm.hypothesisLastRunMode === "relaxed" ||
                                (_vm.mechanismDiagnosticAssessment &&
                                  _vm.mechanismDiagnosticAssessment
                                    .exploratory_mode === true)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "px-3 py-2 mb-0 border-bottom",
                                        staticStyle: {
                                          background: "#fff8e6",
                                          "border-color": "#f0d060 !important",
                                          color: "#5c4a00",
                                        },
                                        attrs: { role: "status" },
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v("Exploratory hypothesis."),
                                        ]),
                                        _vm.isGeneSetEntryMode
                                          ? [
                                              _vm._v(
                                                " This run used relaxed mode: check diagnostic warnings—interpretation may bridge sparse gene set cluster membership not proven by dense gene-set overlap. "
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                " This run used relaxed mode: check diagnostic warnings and Biolink map edge validation—speculative interpretation may bridge gaps not proven by single-hop graph evidence. "
                                              ),
                                            ],
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mechanism-card-header px-3 py-3 bg-secondary text-white d-flex align-items-center flex-wrap gap-2",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "mechanism-card-title" },
                                      [_vm._v(_vm._s(mechanism.group_name))]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column",
                                      gap: "20px",
                                      padding: "20px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mechanism-hypothesis-block",
                                        class: {
                                          "has-pathway-shift":
                                            !!mechanism.pathway_shift_rationale,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mechanism-hypothesis-main",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mechanism-section-label mb-1",
                                              },
                                              [_vm._v("Mechanistic hypothesis")]
                                            ),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(mechanism.hypothesis)
                                              ),
                                            ]),
                                            _vm.isGeneSetEntryMode &&
                                            mechanism.rationale
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mt-3" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mechanism-section-label mb-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Biological rationale"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          mechanism.rationale
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : !_vm.isGeneSetEntryMode &&
                                                (mechanism.novelty_explanation ||
                                                  mechanism.novelty)
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mt-3" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mechanism-section-label mb-1",
                                                      },
                                                      [_vm._v("Rationale")]
                                                    ),
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          mechanism.novelty_explanation ||
                                                            mechanism.novelty
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        mechanism.pathway_shift_rationale
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mechanism-hypothesis-shift alert alert-warning py-2 px-3 mb-0",
                                                attrs: { role: "status" },
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    "Why the hypothesis shifted:"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      mechanism.pathway_shift_rationale
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    !_vm.isGeneSetEntryMode &&
                                    mechanism.relevance
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mechanism-section-label mb-1",
                                            },
                                            [_vm._v("Relevance")]
                                          ),
                                          _c("div", [
                                            _vm._v(_vm._s(mechanism.relevance)),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    mechanism.core_spine_network &&
                                    mechanism.core_spine_network.nodes &&
                                    mechanism.core_spine_network.nodes.length
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mechanism-section-label mb-2",
                                            },
                                            [
                                              _vm._v(
                                                " Hypothesis map (biological mechanism) "
                                              ),
                                            ]
                                          ),
                                          mechanism.hypothesis_in_kg &&
                                          mechanism.hypothesis_in_kg.caption
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mechanism-hypothesis-caption mb-2",
                                                },
                                                _vm._l(
                                                  _vm.splitHypothesisCaption(
                                                    mechanism.hypothesis_in_kg
                                                      .caption
                                                  ),
                                                  function (seg, sidx) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key:
                                                          "cap-" +
                                                          idx +
                                                          "-" +
                                                          sidx,
                                                        staticClass:
                                                          "mechanism-hypothesis-caption-item",
                                                      },
                                                      [
                                                        sidx > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mechanism-hypothesis-caption-sep",
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true",
                                                                },
                                                              },
                                                              [_vm._v("→")]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pill mechanism-hypothesis-caption-pill",
                                                          },
                                                          [_vm._v(_vm._s(seg))]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "min-height": "220px",
                                              },
                                            },
                                            [
                                              _c("factor-base-reveal-network", {
                                                key:
                                                  "core-spine-" +
                                                  idx +
                                                  "-" +
                                                  (mechanism.group_name || ""),
                                                ref:
                                                  "mechanismHypothesisMap-" +
                                                  idx,
                                                refInFor: true,
                                                attrs: {
                                                  network:
                                                    mechanism.core_spine_network,
                                                  genes:
                                                    mechanism.candidate_genes ||
                                                    mechanism.genes ||
                                                    [],
                                                  width: 640,
                                                  height: 280,
                                                  "show-popup-button": true,
                                                  "is-mechanism-flow-map": true,
                                                  "is-biolink-map":
                                                    _vm.helpers.isMechanismUsingBiolinkMap(
                                                      mechanism
                                                    ),
                                                  "show-hypothesis-map-view-toggle":
                                                    _vm.helpers.hasMechanismBiolinkNetwork(
                                                      mechanism
                                                    ),
                                                  "show-original-hypothesis-map":
                                                    !_vm.helpers.isMechanismUsingBiolinkMap(
                                                      mechanism
                                                    ),
                                                },
                                                on: {
                                                  "hypothesis-original-map":
                                                    function ($event) {
                                                      return _vm.$emit(
                                                        "set-mechanism-map-view",
                                                        idx,
                                                        $event
                                                          ? "original"
                                                          : "biolink"
                                                      )
                                                    },
                                                  "open-popup": function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "open-network-popup",
                                                      {
                                                        index: idx,
                                                        hypothesisMap: true,
                                                      }
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.helpers.isMechanismUsingBiolinkMap(
                                            mechanism
                                          )
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-muted mt-2 mb-0",
                                                },
                                                [
                                                  _vm._v(
                                                    " Nodes in this view are mapped to Biolink Model categories (classes), and edges are labeled with Biolink predicates to standardize relationship types across knowledge graphs. Edge support is then checked through the NCATS Biomedical Data Translator using TRAPI queries against Translator knowledge sources. "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                    (mechanism.associated_factor_ids &&
                                      mechanism.associated_factor_ids.length) ||
                                    (mechanism.cited_gene_set_names &&
                                      mechanism.cited_gene_set_names.length) ||
                                    (mechanism.relevant_gene_sets &&
                                      mechanism.relevant_gene_sets.length) ||
                                    (mechanism.associated_pairs &&
                                      mechanism.associated_pairs.length) ||
                                    (!_vm.isGeneSetEntryMode &&
                                      mechanism.relevant_phenotypes &&
                                      mechanism.relevant_phenotypes.length) ||
                                    (!_vm.isGeneSetEntryMode &&
                                      mechanism.redundant_associated_pairs &&
                                      mechanism.redundant_associated_pairs
                                        .length)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mechanism-evidence-columns",
                                          },
                                          [
                                            (!_vm.isGeneSetEntryMode &&
                                              mechanism.relevant_phenotypes &&
                                              mechanism.relevant_phenotypes
                                                .length) ||
                                            (mechanism.associated_factor_ids &&
                                              mechanism.associated_factor_ids
                                                .length) ||
                                            (mechanism.associated_pairs &&
                                              mechanism.associated_pairs.length)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mechanism-evidence-half",
                                                  },
                                                  [
                                                    !_vm.isGeneSetEntryMode &&
                                                    mechanism.relevant_phenotypes &&
                                                    mechanism
                                                      .relevant_phenotypes
                                                      .length
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mechanism-section-label mb-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Relevant phenotypes"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "reveal-evidence-chips",
                                                            },
                                                            _vm._l(
                                                              _vm.helpers.getRelevantPhenotypesDisplay(
                                                                mechanism.relevant_phenotypes
                                                              ),
                                                              function (
                                                                phenotypeLabel,
                                                                pidx
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key:
                                                                      "mech-" +
                                                                      idx +
                                                                      "-rphen-" +
                                                                      pidx +
                                                                      "-" +
                                                                      (phenotypeLabel ||
                                                                        ""),
                                                                    staticClass:
                                                                      "pill text-white",
                                                                    style: `background:${_vm.nodeColors.Phenotype}`,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          phenotypeLabel
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    mechanism.associated_factor_ids &&
                                                    mechanism
                                                      .associated_factor_ids
                                                      .length
                                                      ? _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "mt-3":
                                                                !_vm.isGeneSetEntryMode &&
                                                                mechanism.relevant_phenotypes &&
                                                                mechanism
                                                                  .relevant_phenotypes
                                                                  .length,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mechanism-section-label mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Associated gene set clusters"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "reveal-evidence-chips",
                                                              },
                                                              _vm._l(
                                                                mechanism.associated_factor_ids,
                                                                function (
                                                                  fid,
                                                                  fidx
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        "mech-" +
                                                                        idx +
                                                                        "-afid-" +
                                                                        fidx +
                                                                        "-" +
                                                                        fid,
                                                                      staticClass:
                                                                        "pill text-white",
                                                                      style: `background:${
                                                                        _vm
                                                                          .nodeColors
                                                                          .Factor ||
                                                                        "#6c757d"
                                                                      }`,
                                                                      attrs: {
                                                                        title:
                                                                          String(
                                                                            fid
                                                                          ),
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.helpers.getGeneSetFactorDisplayLabel(
                                                                              fid
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        )
                                                      : mechanism.associated_pairs &&
                                                        mechanism
                                                          .associated_pairs
                                                          .length
                                                      ? _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "mt-3":
                                                                !_vm.isGeneSetEntryMode &&
                                                                mechanism.relevant_phenotypes &&
                                                                mechanism
                                                                  .relevant_phenotypes
                                                                  .length,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mechanism-section-label mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Associated gene set clusters"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "reveal-evidence-chips",
                                                              },
                                                              _vm._l(
                                                                mechanism.associated_pairs,
                                                                function (
                                                                  pair,
                                                                  ridx
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        "mech-" +
                                                                        idx +
                                                                        "-ap-" +
                                                                        ridx +
                                                                        "-" +
                                                                        (pair.factor ||
                                                                          ""),
                                                                      staticClass:
                                                                        "pill text-white",
                                                                      style: `background:${
                                                                        _vm
                                                                          .nodeColors
                                                                          .Factor ||
                                                                        "#6c757d"
                                                                      }`,
                                                                      attrs: {
                                                                        title:
                                                                          String(
                                                                            pair.factor ||
                                                                              pair.phenotype ||
                                                                              ""
                                                                          ),
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.helpers.getGeneSetFactorDisplayLabel(
                                                                              pair.factor ||
                                                                                pair.phenotype
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            (mechanism.cited_gene_set_names &&
                                              mechanism.cited_gene_set_names
                                                .length) ||
                                            (mechanism.relevant_gene_sets &&
                                              mechanism.relevant_gene_sets
                                                .length)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mechanism-evidence-half",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mechanism-section-label mb-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.isGeneSetEntryMode
                                                              ? "Cited gene sets"
                                                              : "Cited / relevant gene sets"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "normal",
                                                          display: "flex",
                                                          "flex-direction":
                                                            "column",
                                                          gap: "6px",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.helpers.formatRelevantGeneSetsForDisplay(
                                                          mechanism.cited_gene_set_names &&
                                                            mechanism
                                                              .cited_gene_set_names
                                                              .length
                                                            ? mechanism.cited_gene_set_names
                                                            : mechanism.relevant_gene_sets
                                                        ),
                                                        function (set) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "mech-" +
                                                                idx +
                                                                "-cgs-" +
                                                                set.gs,
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    display:
                                                                      "flex",
                                                                    gap: "10px",
                                                                    "justify-content":
                                                                      "space-between",
                                                                    "align-items":
                                                                      "flex-start",
                                                                    "flex-wrap":
                                                                      "wrap",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "pill text-white text-decoration-none cfde-explore-geneset-link",
                                                                      staticStyle:
                                                                        {
                                                                          overflow:
                                                                            "clip",
                                                                          "text-overflow":
                                                                            "ellipsis",
                                                                          "max-width":
                                                                            "360px",
                                                                        },
                                                                      style: `background:${_vm.nodeColors.Pathway}`,
                                                                      attrs: {
                                                                        href: _vm.helpers.cfdeExploreGeneSetHref(
                                                                          mechanism,
                                                                          set.gs,
                                                                          set.program
                                                                        ),
                                                                        target:
                                                                          "_blank",
                                                                        rel: "noopener noreferrer",
                                                                        title:
                                                                          set.desc ||
                                                                          set.gs,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          set.gs
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex flex-wrap align-items-center fbr-relevant-geneset-programs",
                                                                      staticStyle:
                                                                        {
                                                                          gap: "6px",
                                                                          "max-width":
                                                                            "min(100%, 560px)",
                                                                          "justify-content":
                                                                            "flex-end",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm.helpers.c2m2GeneSetDownloadNodes(
                                                                        set.gs
                                                                      ).length
                                                                        ? [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "fbr-program-download-wrap",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pill text-white d-inline-flex align-items-center fbr-program-download-trigger",
                                                                                    style:
                                                                                      {
                                                                                        background:
                                                                                          _vm
                                                                                            .nodeColors
                                                                                            .GeneSetProgramDownloads,
                                                                                      },
                                                                                    attrs:
                                                                                      {
                                                                                        role: "button",
                                                                                        tabindex:
                                                                                          "0",
                                                                                        title:
                                                                                          (set.program ||
                                                                                            "Data files") +
                                                                                          " — hover for download links",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "fbr-program-download-label",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            set.program ||
                                                                                              "Data files"
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "b-icon",
                                                                                      {
                                                                                        staticClass:
                                                                                          "fbr-program-download-icon ml-1 flex-shrink-0",
                                                                                        attrs:
                                                                                          {
                                                                                            icon: "three-dots-vertical",
                                                                                            "aria-hidden":
                                                                                              "true",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fbr-program-download-menu border rounded bg-white shadow-sm",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "fbr-program-download-menu-heading px-2 pt-2 pb-1 text-muted text-uppercase",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Open or download"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _vm._l(
                                                                                      _vm.helpers.c2m2GeneSetDownloadNodes(
                                                                                        set.gs
                                                                                      ),
                                                                                      function (
                                                                                        pn,
                                                                                        nidx
                                                                                      ) {
                                                                                        return _c(
                                                                                          "a",
                                                                                          {
                                                                                            key:
                                                                                              "mech-" +
                                                                                              idx +
                                                                                              "-cgs-prov-" +
                                                                                              set.gs +
                                                                                              "-" +
                                                                                              nidx +
                                                                                              "-" +
                                                                                              pn.id,
                                                                                            staticClass:
                                                                                              "fbr-provenance-menu-link d-block px-2 py-1 text-dark text-decoration-none",
                                                                                            attrs:
                                                                                              {
                                                                                                href: pn.dcc_url,
                                                                                                target:
                                                                                                  "_blank",
                                                                                                rel: "noopener noreferrer",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                pn.id
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  2
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        : _vm.helpers.c2m2ProvenanceEntry(
                                                                            set.gs
                                                                          ) &&
                                                                          _vm.helpers.c2m2ProvenanceEntry(
                                                                            set.gs
                                                                          )
                                                                            .status ===
                                                                            "loading"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "text-muted",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Provenance…"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : [
                                                                            set.program
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pill",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        set.program
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                    ],
                                                                    2
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.isGeneSetEntryMode &&
                                            mechanism.redundant_associated_pairs &&
                                            mechanism.redundant_associated_pairs
                                              .length
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mechanism-evidence-full",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mechanism-section-label mb-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Related data categories"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reveal-evidence-chips",
                                                      },
                                                      _vm._l(
                                                        mechanism.redundant_associated_pairs,
                                                        function (pair, ridx) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "mech-" +
                                                                idx +
                                                                "-red-" +
                                                                ridx +
                                                                "-" +
                                                                (pair.factor ||
                                                                  ""),
                                                              staticClass:
                                                                "pill",
                                                              staticStyle: {
                                                                background:
                                                                  "#e2e3e5",
                                                                color:
                                                                  "#383d41",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.helpers.getPhenotypeDisplay(
                                                                      pair.phenotype
                                                                    )
                                                                  ) +
                                                                  " - " +
                                                                  _vm._s(
                                                                    _vm.helpers.getFactorClusterDisplayString(
                                                                      pair.factor
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    (mechanism.candidate_genes &&
                                      mechanism.candidate_genes.length) ||
                                    (mechanism.genes && mechanism.genes.length)
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mechanism-section-label mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  "Candidate genes (" +
                                                    _vm._s(
                                                      (
                                                        mechanism.candidate_genes ||
                                                        mechanism.genes ||
                                                        []
                                                      ).length
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                            _vm.isGeneSetEntryMode
                                              ? _c("b-table", {
                                                  attrs: {
                                                    striped: "",
                                                    hover: "",
                                                    responsive: "sm",
                                                    "head-variant": "light",
                                                    items:
                                                      mechanism.candidate_genes ||
                                                      mechanism.genes ||
                                                      [],
                                                    fields: [
                                                      {
                                                        key: "gene",
                                                        label: "Gene",
                                                        thStyle: {
                                                          width: "90px",
                                                        },
                                                      },
                                                      {
                                                        key: "group",
                                                        label: "Gene role",
                                                        thStyle: {
                                                          width: "200px",
                                                        },
                                                      },
                                                      {
                                                        key: "in_search",
                                                        label: "In search",
                                                        thStyle: {
                                                          width: "80px",
                                                        },
                                                      },
                                                      {
                                                        key: "reason",
                                                        label: "Reason",
                                                      },
                                                      {
                                                        key: "gene_sets",
                                                        label:
                                                          "Cited gene sets",
                                                        thStyle: {
                                                          width: "180px",
                                                        },
                                                      },
                                                      {
                                                        key: "scores_factor_relevance",
                                                        label:
                                                          "Gene set cluster relevance",
                                                        thStyle: {
                                                          width: "110px",
                                                        },
                                                      },
                                                      {
                                                        key: "scores_gene_score",
                                                        label: "Gene score",
                                                        thStyle: {
                                                          width: "90px",
                                                        },
                                                      },
                                                    ],
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "head(reason)",
                                                        fn: function () {
                                                          return [
                                                            _vm._v(" Reason "),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                      {
                                                        key: "cell(in_search)",
                                                        fn: function (row) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.helpers.isGeneInSearchSet(
                                                                    row.item
                                                                  ) === true
                                                                    ? "Yes"
                                                                    : _vm.helpers.isGeneInSearchSet(
                                                                        row.item
                                                                      ) ===
                                                                      false
                                                                    ? "No"
                                                                    : "—"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(scores_factor_relevance)",
                                                        fn: function (row) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.item
                                                                    .scores &&
                                                                    (row.item
                                                                      .scores
                                                                      .factor_relevance !=
                                                                      null ||
                                                                      row.item
                                                                        .scores
                                                                        .combined !=
                                                                        null)
                                                                    ? Number(
                                                                        row.item
                                                                          .scores
                                                                          .factor_relevance ??
                                                                          row
                                                                            .item
                                                                            .scores
                                                                            .combined
                                                                      ).toFixed(
                                                                        3
                                                                      )
                                                                    : "—"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(scores_gene_score)",
                                                        fn: function (row) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.item
                                                                    .scores &&
                                                                    (row.item
                                                                      .scores
                                                                      .gene_score !=
                                                                      null ||
                                                                      row.item
                                                                        .scores
                                                                        .functional !=
                                                                        null)
                                                                    ? Number(
                                                                        row.item
                                                                          .scores
                                                                          .gene_score ??
                                                                          row
                                                                            .item
                                                                            .scores
                                                                            .functional
                                                                      ).toFixed(
                                                                        3
                                                                      )
                                                                    : "—"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(reason)",
                                                        fn: function (row) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.item
                                                                    .reason !=
                                                                    null
                                                                    ? row.item
                                                                        .reason
                                                                    : row.item
                                                                        .role
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(gene)",
                                                        fn: function (row) {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "pill mechanism-gene-symbol",
                                                                style:
                                                                  _vm.helpers.mechanismGeneGroupPillStyle(
                                                                    row.item
                                                                      .group
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.item
                                                                      .gene
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(gene_sets)",
                                                        fn: function (row) {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mechanism-gene-sets-cell",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.helpers.formatGeneSetNamesForTableWrap(
                                                                        _vm.visibleCandidateGeneSets(
                                                                          mechanism,
                                                                          row
                                                                            .item
                                                                            .gene,
                                                                          idx
                                                                        )
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _vm.getCandidateGeneSetsList(
                                                                  mechanism,
                                                                  row.item.gene
                                                                ).length > 5
                                                                  ? _c(
                                                                      "button",
                                                                      {
                                                                        staticClass:
                                                                          "mechanism-gene-sets-toggle",
                                                                        attrs: {
                                                                          type: "button",
                                                                          "aria-expanded":
                                                                            _vm.isCandidateGeneSetsExpanded(
                                                                              idx,
                                                                              row
                                                                                .item
                                                                                .gene
                                                                            )
                                                                              ? "true"
                                                                              : "false",
                                                                          "aria-label":
                                                                            _vm.isCandidateGeneSetsExpanded(
                                                                              idx,
                                                                              row
                                                                                .item
                                                                                .gene
                                                                            )
                                                                              ? "Show fewer gene sets"
                                                                              : "Show more gene sets",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.toggleCandidateGeneSets(
                                                                                idx,
                                                                                row
                                                                                  .item
                                                                                  .gene
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.isCandidateGeneSetsExpanded(
                                                                              idx,
                                                                              row
                                                                                .item
                                                                                .gene
                                                                            )
                                                                              ? "-"
                                                                              : "+"
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(group)",
                                                        fn: function (row) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.item
                                                                    .group ||
                                                                    "—"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                })
                                              : _c("b-table", {
                                                  staticClass:
                                                    "mechanism-candidate-genes-table",
                                                  attrs: {
                                                    striped: "",
                                                    hover: "",
                                                    responsive: "sm",
                                                    "head-variant": "light",
                                                    items:
                                                      mechanism.candidate_genes ||
                                                      mechanism.genes ||
                                                      [],
                                                    fields: [
                                                      {
                                                        key: "gene",
                                                        label: "Gene",
                                                        thStyle: {
                                                          width: "15%",
                                                        },
                                                        tdClass: "align-top",
                                                      },
                                                      {
                                                        key: "group",
                                                        label: "Gene role",
                                                        thStyle: {
                                                          width: "20%",
                                                        },
                                                        tdClass: "align-top",
                                                      },
                                                      {
                                                        key: "reason",
                                                        label: "Reason",
                                                        thStyle: {
                                                          width: "20%",
                                                        },
                                                        tdClass: "align-top",
                                                      },
                                                      {
                                                        key: "gene_sets",
                                                        label:
                                                          "Gene sets (selected row)",
                                                        thStyle: {
                                                          width: "45%",
                                                        },
                                                        tdClass: "align-top",
                                                      },
                                                    ],
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "head(reason)",
                                                        fn: function () {
                                                          return [
                                                            _vm._v(" Reason "),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                      {
                                                        key: "cell(reason)",
                                                        fn: function (row) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.item
                                                                    .reason !=
                                                                    null
                                                                    ? row.item
                                                                        .reason
                                                                    : row.item
                                                                        .role
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(gene)",
                                                        fn: function (row) {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "pill mechanism-gene-symbol",
                                                                style:
                                                                  _vm.helpers.mechanismGeneGroupPillStyle(
                                                                    row.item
                                                                      .group
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.item
                                                                      .gene
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(gene_sets)",
                                                        fn: function (row) {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mechanism-gene-sets-cell",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.helpers.formatGeneSetNamesForTableWrap(
                                                                        _vm.visibleCandidateGeneSets(
                                                                          mechanism,
                                                                          row
                                                                            .item
                                                                            .gene,
                                                                          idx
                                                                        )
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _vm.getCandidateGeneSetsList(
                                                                  mechanism,
                                                                  row.item.gene
                                                                ).length > 5
                                                                  ? _c(
                                                                      "button",
                                                                      {
                                                                        staticClass:
                                                                          "mechanism-gene-sets-toggle",
                                                                        attrs: {
                                                                          type: "button",
                                                                          "aria-expanded":
                                                                            _vm.isCandidateGeneSetsExpanded(
                                                                              idx,
                                                                              row
                                                                                .item
                                                                                .gene
                                                                            )
                                                                              ? "true"
                                                                              : "false",
                                                                          "aria-label":
                                                                            _vm.isCandidateGeneSetsExpanded(
                                                                              idx,
                                                                              row
                                                                                .item
                                                                                .gene
                                                                            )
                                                                              ? "Show fewer gene sets"
                                                                              : "Show more gene sets",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.toggleCandidateGeneSets(
                                                                                idx,
                                                                                row
                                                                                  .item
                                                                                  .gene
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.isCandidateGeneSetsExpanded(
                                                                              idx,
                                                                              row
                                                                                .item
                                                                                .gene
                                                                            )
                                                                              ? "-"
                                                                              : "+"
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(group)",
                                                        fn: function (row) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.item
                                                                    .group ||
                                                                    "—"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.isGeneSetEntryMode &&
                                    mechanism.genes_collective_reason
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mechanism-section-label mb-1",
                                            },
                                            [_vm._v("Genes collective reason")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bg-warning bg-opacity-25 p-2 rounded",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  mechanism.genes_collective_reason
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    !_vm.isGeneSetEntryMode &&
                                    (mechanism.supporting_network ||
                                      mechanism.network) &&
                                    ((
                                      mechanism.supporting_network ||
                                      mechanism.network
                                    ).nodes ||
                                      (
                                        mechanism.supporting_network ||
                                        mechanism.network
                                      ).edges)
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mechanism-section-label mb-2",
                                            },
                                            [_vm._v("Supporting network")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "text-muted mb-2" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    (
                                                      (
                                                        mechanism.supporting_network ||
                                                        mechanism.network
                                                      ).nodes || []
                                                    ).length
                                                  ) +
                                                  " nodes, " +
                                                  _vm._s(
                                                    (
                                                      (
                                                        mechanism.supporting_network ||
                                                        mechanism.network
                                                      ).edges || []
                                                    ).length
                                                  ) +
                                                  " edges "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "min-height": "220px",
                                              },
                                            },
                                            [
                                              _c("factor-base-reveal-network", {
                                                key:
                                                  "support-" +
                                                  (mechanism.group_name || idx),
                                                ref: "mechanismNetwork-" + idx,
                                                refInFor: true,
                                                attrs: {
                                                  network:
                                                    mechanism.supporting_network ||
                                                    mechanism.network,
                                                  genes:
                                                    mechanism.candidate_genes ||
                                                    mechanism.genes ||
                                                    [],
                                                  width: 640,
                                                  height: 360,
                                                  "show-popup-button": true,
                                                  "keep-physics-enabled": "",
                                                  "use-gene-role-colors": false,
                                                  "highlight-anchor-genes": "",
                                                },
                                                on: {
                                                  "open-popup": function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "open-network-popup",
                                                      {
                                                        index: idx,
                                                        hypothesisMap: false,
                                                      }
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    mechanism.next_steps &&
                                    mechanism.next_steps.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mt-2 mb-1 border-top pt-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mechanism-section-label mb-2",
                                              },
                                              [_vm._v("Recommended next steps")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column",
                                                staticStyle: { gap: "8px" },
                                              },
                                              _vm._l(
                                                mechanism.next_steps,
                                                function (step, sidx) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "step-" +
                                                        idx +
                                                        "-" +
                                                        sidx,
                                                      staticClass:
                                                        "p-2 border rounded bg-white",
                                                      staticStyle: {
                                                        "border-left":
                                                          "4px solid #f16822 !important",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "badge badge-secondary mr-2 mb-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              step.category
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "strong",
                                                        {
                                                          staticClass:
                                                            "text-dark",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(step.action)
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                step.reason
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.helpers.isNextStepExperimentalValidation(
                                                        step
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-2",
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-cfde btn-sm",
                                                                  attrs: {
                                                                    type: "button",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.$emit(
                                                                          "open-design-protocol",
                                                                          mechanism,
                                                                          step
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Design experiment protocol "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    mechanism.next_queries &&
                                    mechanism.next_queries.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "reveal-alt-queries-block mt-3 mb-0 border-top pt-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mechanism-section-label mb-1",
                                              },
                                              [
                                                _vm._v(
                                                  "Explore further (next queries)"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "reveal-alt-query-links mb-0",
                                              },
                                              _vm._l(
                                                mechanism.next_queries,
                                                function (query, qidx) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key:
                                                        "nq-" +
                                                        idx +
                                                        "-" +
                                                        qidx,
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "reveal-alt-query-link",
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.$emit(
                                                                "select-alternative-query",
                                                                query
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(query))]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mechanism-llm-handoff-actions d-flex flex-wrap align-items-center mt-3 pt-3 border-top",
                                        staticStyle: { gap: "8px" },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-outline-secondary",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.$emit(
                                                  "copy-mechanism-for-llm",
                                                  mechanism,
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              staticClass: "mr-1",
                                              attrs: { icon: "clipboard" },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.handoffCopiedMechanismIndex ===
                                                    idx
                                                    ? "Copied!"
                                                    : "Copy for LLM"
                                                ) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-outline-secondary",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.$emit(
                                                  "download-mechanism-handoff",
                                                  mechanism,
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              staticClass: "mr-1",
                                              attrs: { icon: "download" },
                                            }),
                                            _vm._v(" Download handoff data "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm.remainingRows.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "remaining-gene-clusters mt-5 pt-4 border-top",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold mb-2",
                                      staticStyle: { color: "#FF6600" },
                                    },
                                    [_vm._v(" Remaining gene set clusters ")]
                                  ),
                                  _c("p", { staticClass: "text-muted mb-3" }, [
                                    _vm._v(
                                      " These phenotype-gene set cluster pairs were included in your data selection but are not yet covered by supporting evidence in the generated hypotheses. "
                                    ),
                                  ]),
                                  _vm.remainingPairGenerateError
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "alert alert-danger mb-3",
                                          attrs: { role: "alert" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.remainingPairGenerateError
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "criteria-detail" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _vm.isPhenotypePath
                                            ? _c(
                                                "b-table-simple",
                                                {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    striped: "",
                                                    hover: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      attrs: {
                                                        variant: "light",
                                                      },
                                                    },
                                                    [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticStyle: {
                                                              width: "72px",
                                                            },
                                                          },
                                                          [_vm._v("Included")]
                                                        ),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticStyle: {
                                                              width: "auto",
                                                            },
                                                          },
                                                          [_vm._v("Phenotype")]
                                                        ),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticStyle: {
                                                              width: "auto",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Gene set cluster"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticStyle: {
                                                              width: "300px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Genes and gene sets in cluster"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticStyle: {
                                                              width: "130px",
                                                            },
                                                          },
                                                          [_vm._v("Hypothesis")]
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._l(
                                                    _vm.remainingFactorTableRowsPaged,
                                                    function (row) {
                                                      return _c(
                                                        "tbody",
                                                        {
                                                          key:
                                                            "rem-" +
                                                            _vm.helpers.getRowKey(
                                                              row
                                                            ),
                                                        },
                                                        [
                                                          _c("tr", [
                                                            _c("td", [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "form-check-input d-inline-block",
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                      "aria-label":
                                                                        "Included",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        row.included,
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.helpers.getPhenotypeDisplay(
                                                                    row.phenotype
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.helpers.getFactorClusterDisplay(
                                                                    row
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "center",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-sm btn-outline-primary",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.$emit(
                                                                            "toggle-factor-row",
                                                                            {
                                                                              item: row,
                                                                            }
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.helpers.isFactorRowExpanded(
                                                                            row
                                                                          )
                                                                            ? "Hide"
                                                                            : "Show"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-center align-middle",
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-sm btn-cfde",
                                                                    attrs: {
                                                                      type: "button",
                                                                      disabled:
                                                                        _vm.generatingRemainingRowKey ===
                                                                        _vm.helpers.getRowKey(
                                                                          row
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.$emit(
                                                                            "generate-remaining-pair",
                                                                            row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.generatingRemainingRowKey ===
                                                                    _vm.helpers.getRowKey(
                                                                      row
                                                                    )
                                                                      ? _c(
                                                                          "b-spinner",
                                                                          {
                                                                            staticClass:
                                                                              "mr-1",
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm.generatingRemainingRowKey ===
                                                                    _vm.helpers.getRowKey(
                                                                      row
                                                                    )
                                                                      ? [
                                                                          _vm._v(
                                                                            "Generating… " +
                                                                              _vm._s(
                                                                                _vm.helpers.formatRemainingGenerateElapsed()
                                                                              )
                                                                          ),
                                                                        ]
                                                                      : [
                                                                          _vm._v(
                                                                            "Generate"
                                                                          ),
                                                                        ],
                                                                  ],
                                                                  2
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _vm.helpers.isFactorRowExpanded(
                                                            row
                                                          )
                                                            ? _c("tr", [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "p-0 border-0",
                                                                    attrs: {
                                                                      colspan:
                                                                        "5",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "bg-light",
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            gap: "20px",
                                                                            "flex-wrap":
                                                                              "wrap",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "px-3 pt-2 pb-0 w-100",
                                                                          },
                                                                          [
                                                                            _vm.helpers.getFactorConnectivityNetwork(
                                                                              row
                                                                            ) &&
                                                                            _vm.helpers.getFactorConnectivityNetwork(
                                                                              row
                                                                            )
                                                                              .nodes
                                                                              .length
                                                                              ? _c(
                                                                                  "factor-base-reveal-network",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        network:
                                                                                          _vm.helpers.getFactorConnectivityNetwork(
                                                                                            row
                                                                                          ),
                                                                                        height: 220,
                                                                                        "show-popup-button": true,
                                                                                        "keep-physics-enabled":
                                                                                          "",
                                                                                        "gene-node-metric-key":
                                                                                          "gwas_support",
                                                                                        "gene-color-by-gwas-support":
                                                                                          "",
                                                                                        "edge-distance-metric-key":
                                                                                          "functional_support",
                                                                                      },
                                                                                    on: {
                                                                                      "open-popup":
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.$emit(
                                                                                            "open-factor-connectivity",
                                                                                            row
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm.helpers.getGenesetForFactor(
                                                                          row.phenotype,
                                                                          row.factor
                                                                        )
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "py-2 px-3",
                                                                                staticStyle:
                                                                                  {
                                                                                    display:
                                                                                      "flex",
                                                                                    flex: "1",
                                                                                    "flex-direction":
                                                                                      "column",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-muted mb-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Gene sets in cluster"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "b-table",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        striped:
                                                                                          "",
                                                                                        hover:
                                                                                          "",
                                                                                        responsive:
                                                                                          "sm",
                                                                                        "head-variant":
                                                                                          "light",
                                                                                        items:
                                                                                          _vm.helpers.getGenesetForFactor(
                                                                                            row.phenotype,
                                                                                            row.factor
                                                                                          ),
                                                                                        fields:
                                                                                          [
                                                                                            {
                                                                                              key: "geneset",
                                                                                              label:
                                                                                                "Gene Set",
                                                                                              thClass:
                                                                                                "text-nowrap",
                                                                                            },
                                                                                            {
                                                                                              key: "program",
                                                                                              label:
                                                                                                "Program",
                                                                                              thClass:
                                                                                                "text-nowrap",
                                                                                            },
                                                                                            {
                                                                                              key: "actions",
                                                                                              label:
                                                                                                "Source Data",
                                                                                              thClass:
                                                                                                "text-nowrap",
                                                                                            },
                                                                                          ],
                                                                                      },
                                                                                    scopedSlots:
                                                                                      _vm._u(
                                                                                        [
                                                                                          {
                                                                                            key: "cell(geneset)",
                                                                                            fn: function (
                                                                                              gRow
                                                                                            ) {
                                                                                              return [
                                                                                                _c(
                                                                                                  "a",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "cfde-explore-geneset-link truncate-cell d-inline-block",
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        "max-width":
                                                                                                          "350px",
                                                                                                        "white-space":
                                                                                                          "nowrap",
                                                                                                        overflow:
                                                                                                          "hidden",
                                                                                                        "text-overflow":
                                                                                                          "ellipsis",
                                                                                                      },
                                                                                                    attrs:
                                                                                                      {
                                                                                                        href: _vm.helpers.cfdeExploreAssociationHref(
                                                                                                          row.phenotype,
                                                                                                          gRow
                                                                                                            .item
                                                                                                            .geneset,
                                                                                                          gRow
                                                                                                            .item
                                                                                                            .program
                                                                                                        ),
                                                                                                        target:
                                                                                                          "_blank",
                                                                                                        rel: "noopener noreferrer",
                                                                                                        title:
                                                                                                          gRow
                                                                                                            .item
                                                                                                            .geneset,
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        gRow
                                                                                                          .item
                                                                                                          .geneset
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                          {
                                                                                            key: "cell(actions)",
                                                                                            fn: function (
                                                                                              gRow
                                                                                            ) {
                                                                                              return [
                                                                                                gRow
                                                                                                  .item
                                                                                                  .program ===
                                                                                                "gtex"
                                                                                                  ? _c(
                                                                                                      "button",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "btn btn-sm btn-outline-primary",
                                                                                                        on: {
                                                                                                          click:
                                                                                                            function (
                                                                                                              $event
                                                                                                            ) {
                                                                                                              return _vm.$emit(
                                                                                                                "gene-set-row-toggle",
                                                                                                                gRow
                                                                                                              )
                                                                                                            },
                                                                                                        },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              gRow.detailsShowing
                                                                                                                ? "Hide"
                                                                                                                : "Show"
                                                                                                            ) +
                                                                                                            " "
                                                                                                        ),
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                          {
                                                                                            key: "row-details",
                                                                                            fn: function (
                                                                                              gRow
                                                                                            ) {
                                                                                              return [
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        padding:
                                                                                                          "10px",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm
                                                                                                      .geneSetSources[
                                                                                                      gRow
                                                                                                        .item
                                                                                                        .geneset
                                                                                                    ]
                                                                                                      ? _c(
                                                                                                          "div",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "b-card",
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "a",
                                                                                                                  {
                                                                                                                    attrs:
                                                                                                                      {
                                                                                                                        href: _vm
                                                                                                                          .geneSetSources[
                                                                                                                          gRow
                                                                                                                            .item
                                                                                                                            .geneset
                                                                                                                        ]
                                                                                                                          .geneSetUrl,
                                                                                                                        target:
                                                                                                                          "_blank",
                                                                                                                      },
                                                                                                                  },
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      _vm._s(
                                                                                                                        _vm
                                                                                                                          .geneSetSources[
                                                                                                                          gRow
                                                                                                                            .item
                                                                                                                            .geneset
                                                                                                                        ]
                                                                                                                          .geneSet
                                                                                                                      )
                                                                                                                    ),
                                                                                                                  ]
                                                                                                                ),
                                                                                                                _c(
                                                                                                                  "ul",
                                                                                                                  _vm._l(
                                                                                                                    _vm
                                                                                                                      .geneSetSources[
                                                                                                                      gRow
                                                                                                                        .item
                                                                                                                        .geneset
                                                                                                                    ]
                                                                                                                      .relations,
                                                                                                                    function (
                                                                                                                      rel,
                                                                                                                      i
                                                                                                                    ) {
                                                                                                                      return _c(
                                                                                                                        "li",
                                                                                                                        {
                                                                                                                          key: i,
                                                                                                                          staticClass:
                                                                                                                            "text-muted",
                                                                                                                        },
                                                                                                                        [
                                                                                                                          _c(
                                                                                                                            "div",
                                                                                                                            [
                                                                                                                              _c(
                                                                                                                                "strong",
                                                                                                                                [
                                                                                                                                  _vm._v(
                                                                                                                                    _vm._s(
                                                                                                                                      rel
                                                                                                                                        .method
                                                                                                                                        .predicate
                                                                                                                                    ) +
                                                                                                                                      ": "
                                                                                                                                  ),
                                                                                                                                ]
                                                                                                                              ),
                                                                                                                              _c(
                                                                                                                                "a",
                                                                                                                                {
                                                                                                                                  attrs:
                                                                                                                                    {
                                                                                                                                      href: rel
                                                                                                                                        .file
                                                                                                                                        .dcc_url,
                                                                                                                                      target:
                                                                                                                                        "_blank",
                                                                                                                                    },
                                                                                                                                },
                                                                                                                                [
                                                                                                                                  _vm._v(
                                                                                                                                    _vm._s(
                                                                                                                                      rel
                                                                                                                                        .file
                                                                                                                                        .filename
                                                                                                                                    )
                                                                                                                                  ),
                                                                                                                                ]
                                                                                                                              ),
                                                                                                                            ]
                                                                                                                          ),
                                                                                                                          _c(
                                                                                                                            "div",
                                                                                                                            [
                                                                                                                              _vm._v(
                                                                                                                                " via "
                                                                                                                              ),
                                                                                                                              _c(
                                                                                                                                "a",
                                                                                                                                {
                                                                                                                                  attrs:
                                                                                                                                    {
                                                                                                                                      href: rel
                                                                                                                                        .method
                                                                                                                                        .script,
                                                                                                                                      target:
                                                                                                                                        "_blank",
                                                                                                                                    },
                                                                                                                                },
                                                                                                                                [
                                                                                                                                  _vm._v(
                                                                                                                                    _vm._s(
                                                                                                                                      rel
                                                                                                                                        .method
                                                                                                                                        .type
                                                                                                                                    )
                                                                                                                                  ),
                                                                                                                                ]
                                                                                                                              ),
                                                                                                                              _vm._v(
                                                                                                                                " (" +
                                                                                                                                  _vm._s(
                                                                                                                                    rel
                                                                                                                                      .method
                                                                                                                                      .direction
                                                                                                                                  ) +
                                                                                                                                  ") "
                                                                                                                              ),
                                                                                                                            ]
                                                                                                                          ),
                                                                                                                        ]
                                                                                                                      )
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  0
                                                                                                                ),
                                                                                                              ]
                                                                                                            ),
                                                                                                          ],
                                                                                                          1
                                                                                                        )
                                                                                                      : _c(
                                                                                                          "div",
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "no data available yet."
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                        ],
                                                                                        null,
                                                                                        true
                                                                                      ),
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "subtable-container py-2 px-3",
                                                                            staticStyle:
                                                                              {
                                                                                flex: "1",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm
                                                                              .loadingGenesForFactor[
                                                                              _vm.helpers.getRowKey(
                                                                                row
                                                                              )
                                                                            ]
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-muted mb-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Loading genes…"
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "text-muted mb-2",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Genes share membership with anchor gene(s)"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            !_vm
                                                                              .loadingGenesForFactor[
                                                                              _vm.helpers.getRowKey(
                                                                                row
                                                                              )
                                                                            ]
                                                                              ? _c(
                                                                                  "b-table",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        striped:
                                                                                          "",
                                                                                        hover:
                                                                                          "",
                                                                                        responsive:
                                                                                          "sm",
                                                                                        "head-variant":
                                                                                          "light",
                                                                                        items:
                                                                                          _vm.helpers.getGenesForFactor(
                                                                                            row.phenotype,
                                                                                            row.factor
                                                                                          ),
                                                                                        fields:
                                                                                          [
                                                                                            {
                                                                                              key: "gene",
                                                                                              label:
                                                                                                "Gene",
                                                                                              thStyle:
                                                                                                {
                                                                                                  width:
                                                                                                    "100px",
                                                                                                },
                                                                                            },
                                                                                            {
                                                                                              key: "combined",
                                                                                              label:
                                                                                                "Combined score",
                                                                                              thStyle:
                                                                                                {
                                                                                                  width:
                                                                                                    "110px",
                                                                                                },
                                                                                            },
                                                                                            {
                                                                                              key: "gwasSupport",
                                                                                              label:
                                                                                                "GWAS support",
                                                                                              thStyle:
                                                                                                {
                                                                                                  width:
                                                                                                    "110px",
                                                                                                },
                                                                                            },
                                                                                            {
                                                                                              key: "geneSetSupport",
                                                                                              label:
                                                                                                "Functional support",
                                                                                              thStyle:
                                                                                                {
                                                                                                  width:
                                                                                                    "120px",
                                                                                                },
                                                                                            },
                                                                                          ],
                                                                                        "per-page":
                                                                                          _vm.subtablePerPage,
                                                                                        "current-page":
                                                                                          _vm.helpers.getSubtableCurrentPage(
                                                                                            row
                                                                                          ),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                            !_vm
                                                                              .loadingGenesForFactor[
                                                                              _vm.helpers.getRowKey(
                                                                                row
                                                                              )
                                                                            ] &&
                                                                            _vm.helpers.getGenesForFactor(
                                                                              row.phenotype,
                                                                              row.factor
                                                                            )
                                                                              .length >
                                                                              _vm.subtablePerPage
                                                                              ? _c(
                                                                                  "b-pagination",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pagination-sm justify-content-center mt-2",
                                                                                    attrs:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .subtableCurrentPages[
                                                                                            _vm.helpers.getRowKey(
                                                                                              row
                                                                                            )
                                                                                          ],
                                                                                        "total-rows":
                                                                                          _vm.helpers.getGenesForFactor(
                                                                                            row.phenotype,
                                                                                            row.factor
                                                                                          )
                                                                                            .length,
                                                                                        "per-page":
                                                                                          _vm.subtablePerPage,
                                                                                      },
                                                                                    on: {
                                                                                      input:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          _vm.$emit(
                                                                                            "update:subtable-page",
                                                                                            {
                                                                                              rowKey:
                                                                                                _vm.helpers.getRowKey(
                                                                                                  row
                                                                                                ),
                                                                                              page: $event,
                                                                                            }
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : _c("b-table", {
                                                attrs: {
                                                  items:
                                                    _vm.remainingGeneSetClusterRowsPaged,
                                                  "primary-key": "_rowKey",
                                                  fields: [
                                                    {
                                                      key: "included",
                                                      label: "Included",
                                                      thStyle: {
                                                        width: "72px",
                                                      },
                                                      stickyColumn: false,
                                                    },
                                                    {
                                                      key: "phenotype",
                                                      label: "Phenotype",
                                                      thStyle: {
                                                        width: "120px",
                                                      },
                                                    },
                                                    {
                                                      key: "factorLabel",
                                                      label: "Gene set cluster",
                                                      thStyle: {
                                                        width: "180px",
                                                      },
                                                    },
                                                    {
                                                      key: "rationale",
                                                      label:
                                                        "Selection rationale",
                                                      thStyle: {
                                                        width: "220px",
                                                      },
                                                    },
                                                    {
                                                      key: "view_genes",
                                                      label:
                                                        "Genes and gene sets in cluster",
                                                      thStyle: {
                                                        width: "140px",
                                                      },
                                                    },
                                                    {
                                                      key: "hypothesis",
                                                      label: "Hypothesis",
                                                      thStyle: {
                                                        width: "130px",
                                                      },
                                                    },
                                                  ],
                                                  striped: "",
                                                  hover: "",
                                                  "head-variant": "light",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "cell(included)",
                                                      fn: function (row) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              _c("input", {
                                                                staticClass:
                                                                  "form-check-input d-inline-block",
                                                                attrs: {
                                                                  type: "checkbox",
                                                                  "aria-label":
                                                                    "Included in selection",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    row.item
                                                                      .included,
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "cell(phenotype)",
                                                      fn: function (row) {
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.helpers.getPhenotypeDisplay(
                                                                  row.item
                                                                    .phenotype
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "cell(factorLabel)",
                                                      fn: function (row) {
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.helpers.getFactorClusterDisplay(
                                                                  row.item
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "cell(rationale)",
                                                      fn: function (row) {
                                                        return [
                                                          row.item.rationale
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-muted",
                                                                  staticStyle: {
                                                                    "white-space":
                                                                      "normal",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      row.item
                                                                        .rationale
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-muted",
                                                                },
                                                                [_vm._v("—")]
                                                              ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "cell(view_genes)",
                                                      fn: function (row) {
                                                        return [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-sm btn-outline-primary",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$emit(
                                                                      "toggle-factor-row",
                                                                      row
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.helpers.isFactorRowExpanded(
                                                                      row.item
                                                                    )
                                                                      ? "Hide"
                                                                      : "Show"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "cell(hypothesis)",
                                                      fn: function (row) {
                                                        return [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-sm btn-cfde",
                                                              attrs: {
                                                                type: "button",
                                                                disabled:
                                                                  _vm.generatingRemainingRowKey ===
                                                                  _vm.helpers.getRowKey(
                                                                    row.item
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$emit(
                                                                      "generate-remaining-pair",
                                                                      row.item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm.generatingRemainingRowKey ===
                                                              _vm.helpers.getRowKey(
                                                                row.item
                                                              )
                                                                ? _c(
                                                                    "b-spinner",
                                                                    {
                                                                      staticClass:
                                                                        "mr-1",
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                      },
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              _vm.generatingRemainingRowKey ===
                                                              _vm.helpers.getRowKey(
                                                                row.item
                                                              )
                                                                ? [
                                                                    _vm._v(
                                                                      "Generating… " +
                                                                        _vm._s(
                                                                          _vm.helpers.formatRemainingGenerateElapsed()
                                                                        )
                                                                    ),
                                                                  ]
                                                                : [
                                                                    _vm._v(
                                                                      "Generate"
                                                                    ),
                                                                  ],
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "row-details",
                                                      fn: function (row) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "bg-light",
                                                              staticStyle: {
                                                                display: "flex",
                                                                gap: "20px",
                                                                "flex-wrap":
                                                                  "wrap",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "px-3 pt-2 pb-0 w-100",
                                                                },
                                                                [
                                                                  _vm.helpers.getFactorConnectivityNetwork(
                                                                    row.item
                                                                  ) &&
                                                                  _vm.helpers.getFactorConnectivityNetwork(
                                                                    row.item
                                                                  ).nodes.length
                                                                    ? _c(
                                                                        "factor-base-reveal-network",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              network:
                                                                                _vm.helpers.getFactorConnectivityNetwork(
                                                                                  row.item
                                                                                ),
                                                                              height: 220,
                                                                              "show-popup-button": true,
                                                                              "keep-physics-enabled":
                                                                                "",
                                                                              "gene-node-metric-key":
                                                                                "gwas_support",
                                                                              "gene-color-by-gwas-support":
                                                                                "",
                                                                              "edge-distance-metric-key":
                                                                                "functional_support",
                                                                            },
                                                                          on: {
                                                                            "open-popup":
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$emit(
                                                                                  "open-factor-connectivity",
                                                                                  row.item
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              _vm.helpers.getGenesetForFactor(
                                                                row.item
                                                                  .phenotype,
                                                                row.item.factor
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "py-2 px-3",
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                          flex: "1",
                                                                          "flex-direction":
                                                                            "column",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "text-muted mb-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Gene sets in cluster"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "b-table",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              striped:
                                                                                "",
                                                                              hover:
                                                                                "",
                                                                              responsive:
                                                                                "sm",
                                                                              "head-variant":
                                                                                "light",
                                                                              items:
                                                                                _vm.helpers.getGenesetForFactor(
                                                                                  row
                                                                                    .item
                                                                                    .phenotype,
                                                                                  row
                                                                                    .item
                                                                                    .factor
                                                                                ),
                                                                              fields:
                                                                                [
                                                                                  {
                                                                                    key: "geneset",
                                                                                    label:
                                                                                      "Gene Set",
                                                                                    thClass:
                                                                                      "text-nowrap",
                                                                                  },
                                                                                  {
                                                                                    key: "program",
                                                                                    label:
                                                                                      "Program",
                                                                                    thClass:
                                                                                      "text-nowrap",
                                                                                  },
                                                                                  {
                                                                                    key: "actions",
                                                                                    label:
                                                                                      "Source Data",
                                                                                    thClass:
                                                                                      "text-nowrap",
                                                                                  },
                                                                                ],
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "cell(geneset)",
                                                                                  fn: function (
                                                                                    gRow
                                                                                  ) {
                                                                                    return [
                                                                                      _c(
                                                                                        "a",
                                                                                        {
                                                                                          staticClass:
                                                                                            "cfde-explore-geneset-link truncate-cell d-inline-block",
                                                                                          staticStyle:
                                                                                            {
                                                                                              "max-width":
                                                                                                "350px",
                                                                                              "white-space":
                                                                                                "nowrap",
                                                                                              overflow:
                                                                                                "hidden",
                                                                                              "text-overflow":
                                                                                                "ellipsis",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              href: _vm.helpers.cfdeExploreAssociationHref(
                                                                                                row
                                                                                                  .item
                                                                                                  .phenotype,
                                                                                                gRow
                                                                                                  .item
                                                                                                  .geneset,
                                                                                                gRow
                                                                                                  .item
                                                                                                  .program
                                                                                              ),
                                                                                              target:
                                                                                                "_blank",
                                                                                              rel: "noopener noreferrer",
                                                                                              title:
                                                                                                gRow
                                                                                                  .item
                                                                                                  .geneset,
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              gRow
                                                                                                .item
                                                                                                .geneset
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                                {
                                                                                  key: "cell(actions)",
                                                                                  fn: function (
                                                                                    gRow
                                                                                  ) {
                                                                                    return [
                                                                                      gRow
                                                                                        .item
                                                                                        .program ===
                                                                                      "gtex"
                                                                                        ? _c(
                                                                                            "button",
                                                                                            {
                                                                                              staticClass:
                                                                                                "btn btn-sm btn-outline-primary",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.$emit(
                                                                                                      "gene-set-row-toggle",
                                                                                                      gRow
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    gRow.detailsShowing
                                                                                                      ? "Hide"
                                                                                                      : "Show"
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                                {
                                                                                  key: "row-details",
                                                                                  fn: function (
                                                                                    gRow
                                                                                  ) {
                                                                                    return [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              padding:
                                                                                                "10px",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm
                                                                                            .geneSetSources[
                                                                                            gRow
                                                                                              .item
                                                                                              .geneset
                                                                                          ]
                                                                                            ? _c(
                                                                                                "div",
                                                                                                [
                                                                                                  _c(
                                                                                                    "b-card",
                                                                                                    [
                                                                                                      _c(
                                                                                                        "a",
                                                                                                        {
                                                                                                          attrs:
                                                                                                            {
                                                                                                              href: _vm
                                                                                                                .geneSetSources[
                                                                                                                gRow
                                                                                                                  .item
                                                                                                                  .geneset
                                                                                                              ]
                                                                                                                .geneSetUrl,
                                                                                                              target:
                                                                                                                "_blank",
                                                                                                            },
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm
                                                                                                                .geneSetSources[
                                                                                                                gRow
                                                                                                                  .item
                                                                                                                  .geneset
                                                                                                              ]
                                                                                                                .geneSet
                                                                                                            )
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "ul",
                                                                                                        _vm._l(
                                                                                                          _vm
                                                                                                            .geneSetSources[
                                                                                                            gRow
                                                                                                              .item
                                                                                                              .geneset
                                                                                                          ]
                                                                                                            .relations,
                                                                                                          function (
                                                                                                            rel,
                                                                                                            i
                                                                                                          ) {
                                                                                                            return _c(
                                                                                                              "li",
                                                                                                              {
                                                                                                                key: i,
                                                                                                                staticClass:
                                                                                                                  "text-muted",
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "div",
                                                                                                                  [
                                                                                                                    _c(
                                                                                                                      "strong",
                                                                                                                      [
                                                                                                                        _vm._v(
                                                                                                                          _vm._s(
                                                                                                                            rel
                                                                                                                              .method
                                                                                                                              .predicate
                                                                                                                          ) +
                                                                                                                            ": "
                                                                                                                        ),
                                                                                                                      ]
                                                                                                                    ),
                                                                                                                    _c(
                                                                                                                      "a",
                                                                                                                      {
                                                                                                                        attrs:
                                                                                                                          {
                                                                                                                            href: rel
                                                                                                                              .file
                                                                                                                              .dcc_url,
                                                                                                                            target:
                                                                                                                              "_blank",
                                                                                                                          },
                                                                                                                      },
                                                                                                                      [
                                                                                                                        _vm._v(
                                                                                                                          _vm._s(
                                                                                                                            rel
                                                                                                                              .file
                                                                                                                              .filename
                                                                                                                          )
                                                                                                                        ),
                                                                                                                      ]
                                                                                                                    ),
                                                                                                                  ]
                                                                                                                ),
                                                                                                                _c(
                                                                                                                  "div",
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      " via "
                                                                                                                    ),
                                                                                                                    _c(
                                                                                                                      "a",
                                                                                                                      {
                                                                                                                        attrs:
                                                                                                                          {
                                                                                                                            href: rel
                                                                                                                              .method
                                                                                                                              .script,
                                                                                                                            target:
                                                                                                                              "_blank",
                                                                                                                          },
                                                                                                                      },
                                                                                                                      [
                                                                                                                        _vm._v(
                                                                                                                          _vm._s(
                                                                                                                            rel
                                                                                                                              .method
                                                                                                                              .type
                                                                                                                          )
                                                                                                                        ),
                                                                                                                      ]
                                                                                                                    ),
                                                                                                                    _vm._v(
                                                                                                                      " (" +
                                                                                                                        _vm._s(
                                                                                                                          rel
                                                                                                                            .method
                                                                                                                            .direction
                                                                                                                        ) +
                                                                                                                        ") "
                                                                                                                    ),
                                                                                                                  ]
                                                                                                                ),
                                                                                                              ]
                                                                                                            )
                                                                                                          }
                                                                                                        ),
                                                                                                        0
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            : _c(
                                                                                                "div",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "no data available yet."
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "subtable-container py-2",
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-muted mb-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Genes share membership with anchor gene(s)"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "b-table",
                                                                    {
                                                                      attrs: {
                                                                        striped:
                                                                          "",
                                                                        hover:
                                                                          "",
                                                                        responsive:
                                                                          "sm",
                                                                        "head-variant":
                                                                          "light",
                                                                        items:
                                                                          _vm.helpers.getGenesForFactor(
                                                                            row
                                                                              .item
                                                                              .phenotype,
                                                                            row
                                                                              .item
                                                                              .factor
                                                                          ),
                                                                        fields:
                                                                          [
                                                                            {
                                                                              key: "gene",
                                                                              label:
                                                                                "Gene",
                                                                              thStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                },
                                                                            },
                                                                            {
                                                                              key: "combined",
                                                                              label:
                                                                                "Combined score",
                                                                              thStyle:
                                                                                {
                                                                                  width:
                                                                                    "110px",
                                                                                },
                                                                            },
                                                                            {
                                                                              key: "gwasSupport",
                                                                              label:
                                                                                "GWAS support",
                                                                              thStyle:
                                                                                {
                                                                                  width:
                                                                                    "110px",
                                                                                },
                                                                            },
                                                                            {
                                                                              key: "geneSetSupport",
                                                                              label:
                                                                                "Functional support",
                                                                              thStyle:
                                                                                {
                                                                                  width:
                                                                                    "120px",
                                                                                },
                                                                            },
                                                                          ],
                                                                        "per-page":
                                                                          _vm.subtablePerPage,
                                                                        "current-page":
                                                                          _vm.helpers.getSubtableCurrentPage(
                                                                            row.item
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm.helpers.getGenesForFactor(
                                                                    row.item
                                                                      .phenotype,
                                                                    row.item
                                                                      .factor
                                                                  ).length >
                                                                  _vm.subtablePerPage
                                                                    ? _c(
                                                                        "b-pagination",
                                                                        {
                                                                          staticClass:
                                                                            "pagination-sm justify-content-center mt-2",
                                                                          attrs:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .subtableCurrentPages[
                                                                                  _vm.helpers.getRowKey(
                                                                                    row.item
                                                                                  )
                                                                                ],
                                                                              "total-rows":
                                                                                _vm.helpers.getGenesForFactor(
                                                                                  row
                                                                                    .item
                                                                                    .phenotype,
                                                                                  row
                                                                                    .item
                                                                                    .factor
                                                                                )
                                                                                  .length,
                                                                              "per-page":
                                                                                _vm.subtablePerPage,
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.$emit(
                                                                                  "update:subtable-page",
                                                                                  {
                                                                                    rowKey:
                                                                                      _vm.helpers.getRowKey(
                                                                                        row.item
                                                                                      ),
                                                                                    page: $event,
                                                                                  }
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  527344807
                                                ),
                                              }),
                                          (_vm.isPhenotypePath
                                            ? _vm.remainingTableRowCount
                                            : _vm.remainingRows.length) >
                                          _vm.mainTablePerPage
                                            ? _c("b-pagination", {
                                                staticClass:
                                                  "pagination-sm justify-content-center mt-2",
                                                attrs: {
                                                  value:
                                                    _vm.remainingTableCurrentPage,
                                                  "total-rows":
                                                    _vm.isPhenotypePath
                                                      ? _vm.remainingTableRowCount
                                                      : _vm.remainingRows
                                                          .length,
                                                  "per-page":
                                                    _vm.mainTablePerPage,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.$emit(
                                                      "update:remainingTableCurrentPage",
                                                      $event
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }